module.exports = __webpack_public_path__ + "img/plan02_girl.b2b4e3bb.png";